module.exports = __webpack_public_path__ + "images/category_lp/macbook/assessment_achievements/5@2x_c5b75fb6205ef47df664150a1a92bba9.png";